import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import Home from '@/pages/Home';
import Travel from '@/pages/Travel'
import Shop from '@/pages/Shop';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import NewsList from '@/pages/News/List';
import NewsDetail from '@/pages/News/Detail';
import RecruitList from '@/pages/Recruit/List';
import RecruitDetail from '@/pages/Recruit/Detail';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '/travel',
        element: <Travel />
      },
      {
        path: '/shop',
        element: <Shop />
      },
      {
        path: '/about',
        element: <About />
      },
      {
        path: '/contact',
        element: <Contact />
      },
      {
        path: '/news',
        element: <NewsList />
      },
      {
        path: '/news-detail',
        element: <NewsDetail />
      },
      {
        path: '/recruit',
        element: <RecruitList />
      },
      {
        path: '/recruit-detail',
        element: <RecruitDetail />
      }
    ],
  },
]);

export default router;
